import styled from 'styled-components'
import { ReactNode } from 'react'
import { NavLink } from 'react-router-dom'
import { COLOR } from 'src/constants/colors'

export type CustomNavLinkProps = {
  children?: ReactNode
  display?: string
  onClick?: any
  width?: string
  height?: string
  $position?: string
  $padding?: string
  $margin?: string
  $gap?: string
  $justify_content?: string
  $bgColor?: string
  $border_radius?: string
  $flex_wrap?: string
  $border?: string
  background_image?: string
  $align_item?: string
  style?: Object
  $flex_direction?: string
  $min_height?: string
  $min_width?: string
  $max_height?: string
  className?: string
  $align_content?: string
  $hover?: string
  link: string
}
const CustomNavLink = (props: CustomNavLinkProps) => {
  return (
    <NavLinkWrap to={props.link} {...props} onClick={props.onClick}>
      {props.children}
    </NavLinkWrap>
  )
}

const NavLinkWrap = styled(NavLink)<CustomNavLinkProps>`
  display: ${(props) => props.display || 'block'};
  padding: ${(props) => props.$padding || 0};
  height: ${(props) => props.height || ' auto'};
  width: ${(props) => props.width || 'auto'};
  margin: ${(props) => props.$margin || 0};
  cursor: ${(props) => (props.onClick ? 'pointer' : 'unset')};
  gap: ${(props) => props.$gap};
  background: ${COLOR.white};
  justify-content: ${(props) => props.$justify_content};
  border-radius: ${(props) => props.$border_radius};
  border: ${(props) => props.$border};
  flex-wrap: ${(props) => props.$flex_wrap || 'unset'};
  position: ${(props) => props.$position};
  background-image: url(${(props) => props.background_image});
  background-size: ${(props) => props.background_image && 'cover'};
  background-repeat: ${(props) => props.background_image && 'no-repeat'};
  background-position: ${(props) => props.background_image && '50% 50%'};
  align-items: ${(props) => props.$align_item};
  flex-direction: ${(props) => props.$flex_direction};
  min-height: ${(props) => props.$min_height};
  min-width: ${(props) => props.$min_width};
  max-height: ${(props) => props.$max_height};
  align-content: ${(props) => props.$align_content};
  text-decoration: unset;
  &:hover {
    background: ${COLOR.black2};
  }
  &.active {
    background: ${COLOR.brand};
  }
`
export default CustomNavLink
